import React, { useState } from "react";
import { CheckCircle, XCircle } from "lucide-react";
import { motion } from "framer-motion";

const doThis = [
  "Submit 2–5 minutes of continuous footage",
  "Use a 4K or high-resolution camera (1080p minimum)",
  "Record in a studio-quality environment",
  "Maintain consistent positioning",
  "Natural speech pattern",
  "Approved gestures: Subtle hand movements below chest level",
];

const avoidThis = [
  "Edited/stitched footage (must be single continuous take)",
  "Inconsistent framing (don’t adjust position mid-recording)",
  "Background music or sudden noise spikes",
  "Overexposure or facial shadows",
  "Breaking eye contact with camera",
  "Exaggerated head movements",
  "Hand gestures above shoulder level",
];

const Instructions = ({ onNext }) => {
  const [isInstructionsChecked, setIsInstructionsChecked] = useState(false);

  return (
    <>
      <div className="flex flex-col items-center gap-6 px-40 py-8">
        <div className="grid grid-cols-2 gap-6 w-full ">
          {/* Do This */}
          <div className="border rounded-lg p-3 bg-[#F5F5F5]">
            <div className="flex items-center gap-2 mb-3 p-3 rounded-md bg-[rgba(27,168,86,0.12)]">
              <CheckCircle className="text-[#4BB762]" size={18} />
              <span className="font-semibold text-[2.2vh] text-[#4BB762]">
                Do This
              </span>
            </div>
            <ul className="list-disc space-y-2 p-2 px-5 text-[2vh] text-[#222222]">
              {doThis.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          {/* Avoid This */}
          <div className="border rounded-lg p-3 bg-[#F5F5F5]">
            <div className="flex items-center rounded-md gap-2 mb-3 p-3 bg-[#E43140]/[0.10]">
              <XCircle className="text-[#E43140]" size={18} />
              <span className="font-semibold text-[#E43140] text-[2.2vh]">
                Avoid This
              </span>
            </div>
            <ul className="list-disc space-y-2 p-2 px-5 text-[2vh] text-[#222222]">
              {avoidThis.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center gap-4 mt-6">
        <label className="flex items-center text-[2vh] gap-2 text-[#222222]">
          <input
            type="checkbox"
            checked={isInstructionsChecked}
            onChange={(e) => setIsInstructionsChecked(e.target.checked)}
            className="w-4 h-4 border-1 border-gray-500 rounded-sm accent-indigo-600 bg-white focus:ring-[0.1vh] focus:ring-gray-500"
          />
          Yes, I read all instructions
        </label>

        <button
          type="button"
          className={`w-fit mx-auto py-2 px-4 bg-indigo-600 hover:bg-indigo-700 text-[#fff] rounded-lg text-[2vh] font-medium ${
            !isInstructionsChecked ? `cursor-not-allowed` : `cursor-pointer`
          }`}
          disabled={!isInstructionsChecked}
          onClick={() => {
            if (isInstructionsChecked) {
              onNext();
            }
          }}
        >
          Next
        </button>
      </div>
    </>
  );
};

export default Instructions;
